import React from 'react'

import NotificationSection from './NotificationSection'

import { notificationSections } from '../../../../constants'

const NotificationsContent = () => {
  const notificationsSectionsContent = notificationSections.map((notificationSection) => {
    return (
      <NotificationSection key={notificationSection.id} notificationSection={notificationSection} />
    )
  })

  return (
    <div className="w-full p-[16px] pb-[24px] flex flex-col items-center justify-start max-h-[600px] overflow-y-auto primary-scroll">
      <h3 className="text-[#F67443] text-4xl font-bold font-Inter mb-[24px]">Notifications</h3>

      <div className="w-full flex flex-col gap-y-[32px]">{notificationsSectionsContent}</div>

      <button className="mt-[24px] rounded-full bg-[#FDFDFD] min-h-[40px] border-[#F79009] border-[1px] px-[16px] flex items-center justify-center text-base text-[#F67443] font-medium font-Inter">
        View more
      </button>
    </div>
  )
}

export default NotificationsContent
